import { ResponsiveMixin } from 'vue-responsive-components';

export const breakpointsMixin = {
  mixins: [ResponsiveMixin],
  data() {
    return {
      breakpoints: {
        sm: (el) => el.width <= 320,
        md: (el) => el.width > 320 && el.width < 768,
        lg: (el) => el.width >= 768 && el.width < 1024,
        xl: (el) => el.width > 1024,
        tabletUp: (el) => el.width >= 768,
      },
    };
  },
  methods: {
    getBreakpoints() {
      return this.breakpoints;
    },
  },
};
